'use client'

import HeaderGap from '@/components/atoms/headerGap'
import ResponsiveTitle from '@/components/molecules/responsiveTitle'
import Container from '@/components/templates/container'
import Layout from '@/components/templates/layout'
import Description from './components/description'
import BookCourts from './components/bookCourts'
import Membership from './components/membership'

const BookAndJoinPage = ({ bookAPI, footerAPI, settingAPI }) => {
  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <HeaderGap />
      <Container outerClassName="mt-[97px] lg:mt-[110px]">
        <ResponsiveTitle
          left={bookAPI.title.left}
          center={bookAPI.title.center}
          right={bookAPI.title.right}
          size="small"
        />
      </Container>
      <Description description={bookAPI.description} />
      <BookCourts
        title={bookAPI.bookCourts.title}
        description={bookAPI.bookCourts.description}
        ctaButton={bookAPI.bookCourts.ctaButton}
        image={bookAPI.bookCourts.image}
      />
      <Membership
        title={bookAPI.membership.title}
        description={bookAPI.membership.description}
        ctaButton={bookAPI.membership.ctaButton}
        image={bookAPI.membership.image}
      />
    </Layout>
  )
}

export default BookAndJoinPage
